import { useEffect, useRef, useState } from 'react';
import { getGfxQuality, setGfxQuality, tierBelow } from '../../settings/gfx.quality';

/**
 * If average frame time stays above ~32ms for a window, step quality down once.
 * Helps Fold / thermal throttle after the first seconds of cinematic load.
 */
export function useAdaptiveGfx( enabled = true ) {

  const [ gfx, setGfx ] = useState( () => getGfxQuality() );
  const stepped = useRef( false );

  useEffect(() => {

    if ( !enabled || typeof window === 'undefined' ) return undefined;

    let raf = 0;
    let frames = 0;
    let acc = 0;
    let last = performance.now();

    const sampleWindow = 90; // ~1.5s at 60fps
    const warmup = 45;

    const tick = ( now ) => {

      const dt = now - last;
      last = now;
      frames += 1;

      if ( frames > warmup ) acc += dt;

      if ( frames >= sampleWindow ) {

        const avg = acc / ( sampleWindow - warmup );

        if ( !stepped.current && avg > 32 ) {

          const next = tierBelow( gfx.id );
          if ( next !== gfx.id ) {

            stepped.current = true;
            const q = setGfxQuality( next );
            setGfx({ ...q });
            // eslint-disable-next-line no-console
            console.info( `[gfx] adaptive downgrade → ${ next } (avg frame ${ avg.toFixed( 1 ) }ms)` );

          }

        }

        return;

      }

      raf = requestAnimationFrame( tick );

    };

    raf = requestAnimationFrame( tick );

    return () => cancelAnimationFrame( raf );

  }, [ enabled, gfx.id ]);

  return gfx;

}
